import { httpClient } from '../http/http-client.js';

/** The group a user belongs to, as every endpoint that mentions one returns it. */
export interface GroupRefPayload {
  id: string;
  name: string;
}

export interface SessionResponse {
  email: string;
  group: GroupRefPayload | null;
  /**
   * Codes granted through the group. Plain strings: a deployment can have
   * permissions this build has never heard of, and `can()` still answers.
   */
  permissions: string[];
}

/** What the login answers. Only the email is contractual; the session comes from `me`. */
interface LoginResponse {
  email: string;
}

/**
 * Boundary with the session endpoints.
 *
 * The only place in the frontend that knows which routes the session API has
 * and what shape its response takes. The store works with the view model, not
 * with the wire.
 */
export const sessionApi = {
  /**
   * Boot probe: when there is no session, that is a normal answer and not an
   * incident worth announcing.
   */
  me: (): Promise<SessionResponse> => httpClient.probe<SessionResponse>('/session/me'),

  loginWithGoogle: (code: string, redirectUri: string): Promise<LoginResponse> =>
    httpClient.post<LoginResponse>('/session/login/google', { code, redirectUri }),

  logout: (): Promise<void> => httpClient.delete<void>('/session'),
};
